import { Inject } from '@odinjs/odin';

import { Endpoint, ReportService } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { Report } from '@philips-emr/hpms-stipulator-components';
import { ActionAPI, FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { PersonDataDetailsFormNonEditableAliases as Aliases } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: 'person-data-details-form-non-editable' })
class PersonalDataNonEditableController extends BaseController {

  @Inject(Aliases.ACTION_PRINT)
  private buttonPrint: ActionAPI;

  private reportService: ReportService;

  @OnMount('person-data-fetch-editable')
  onMount(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { cdPessoaFisica, nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    
    api.setParameters({ cdPessoaFisica, nrSeqBeneficiario });
    api.forceFetch();
  }

  @OnBeforeFetch('person-data-fetch-editable')
  onBeforeFetchBeneficiarios(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

  @OnMount(Aliases.ACTION_PRINT)
  onMountAction(): void {
    this.reportService = new ReportService('22', Endpoint.GET.RELATORIOS_POR_GRUPO);
    void this.reportService.getRelatoriosByCdGrupo()
      .then((response: Report[]) => {
        if (response.length === 0) {
          this.buttonPrint.setEnabled(false);
        }
      });
  }

  @OnClick(Aliases.ACTION_PRINT)
  onClickPrint(): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    this.reportService = new ReportService('22', Endpoint.GET.RELATORIOS_POR_GRUPO);
    this.reportService.abreListaRelatorios({ NR_SEQ_SEGURADO: nrSeqBeneficiario });
  }

}

export default PersonalDataNonEditableController;
